import { useTeamRole } from "./teams";

export default function useIsAdminOfTeam(teamId: number): boolean {
  const { role } = useTeamRole({ type: "team", id: teamId });

  return role === "admin";
}
